import { ProjectLastUsedDto } from '../../../api/api-types';

export const getLastTaskName = (employeeData: ProjectLastUsedDto) =>
  employeeData.projectDTOList
    .flatMap((project) => project.tasks)
    .find((task) => task?.eptId === employeeData.lastUsedProject?.eptId)
    ?.name ?? '';
